import {IController} from "angular";
import * as angular from "angular";
import * as _ from "lodash";
import {RoutesService} from "../../../routes/services/routes-service.service";
// import {ExportType} from "../../../lean-planning/types/export.type";
import {RouteModel} from "../../../routes/models/route.model";
import {CommonsDialogService} from "../../../commons/services/commons-dialog.service";
import {TaskType} from "../../../tasks/types/task.type";
import {TaskStatusType} from "../../../tasks/types/taskStatus.type";
import {LeanPlanningService} from "../../../lean-planning/services/lean-planning-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {RouteExportRowType} from "../../enums/route-export-row.type";

export class RoutesActionBarComponent implements IController {
  excludeMode: any;
  totalRoutes: any;
  showTotalsRow?: boolean;
  displayAsIcon?: boolean;
  onlyExport?: boolean
  allRoutesCount: any;
  selectedIds: string[] = [];
  selectedRoutes: RouteModel[] = [];
  onAssignAndSelect: Function;
  onAssign: Function;
  onDelete: Function;
  onMerge: Function;
  onReset: Function;
  onUpdateBranches: Function;
  onExport: Function;
  onExportIntegration: Function;
  onHandleUnpackedServices: Function;
  onReoptimizeRoute: Function;
  onLockRoute: Function;
  onUnlockRoute: Function;
  onUpdateResource: Function;
  onUpdateLogisticsVehicleRoute: Function;
  onManageAssistants: Function;
  onChangeRouteColor: Function;
  onResetSelection: Function;
  onAssociate: Function;


  public siteId: any;
  public allowPrintingBillOfLading: boolean;
  public routesRef: any;
  public routesMenu: any;
  public enabledActions: any;
  public integrationExportRouteEnabled: boolean;
  public exportType: typeof RouteExportRowType = RouteExportRowType;
  public printerProvider: string;
  public deliveriesRef: any;
  public taskTypes: typeof TaskType = TaskType;
  public bindingTask: any;
  public totals: {numberOfItems: number, weightLoad: number, calculatedVolume: number};

  get hasCancelableServices(): boolean {
    return _.some(this.selectedRoutes, (r) => {
      return _.some(r.routeTaskList, (t) => this._isCancelableTask(t));
    });
  }

  private _isCancelableTask(t): boolean {
    return (t.taskType === this.taskTypes.Stopover || t.taskType === this.taskTypes.BundledStopover)
      && t.status !== TaskStatusType.Canceled;
  }

  constructor(private splitService, private $planningRoutes, private $deliveries, private commonsDialogService: CommonsDialogService,
              private routesService: RoutesService, private leanPlanningService: LeanPlanningService, private DeliveriesApiAction) {
    this.siteId = this.splitService.getSiteId();
    this.allowPrintingBillOfLading = this.splitService.isPrintingBillOfLadingAllowed();
    this.routesRef = this.$planningRoutes();
    this.integrationExportRouteEnabled = this.splitService.getSiteIntegrationExportRouteEnabled();
    this.printerProvider = this.splitService.getPrinterProvider();
    this.deliveriesRef = this.$deliveries();

  }

  $onInit() {
    this.enabledActions = this.leanPlanningService.getRoutesActionsMap(this.selectedRoutes);
    this._setTotals();
  }

  $onChanges(changes) {
    if (changes.selectedRoutes && !changes.selectedRoutes.isFirstChange()) {
      this.enabledActions = this.leanPlanningService.getRoutesActionsMap(this.selectedRoutes);

      if (this.selectedRoutes.length === 1) {
        this._setEditableBoundedEquipment(this.selectedRoutes[0]);
      } else {
        this.bindingTask = undefined;
      }

      this._setTotals();
    }
  };


  onOpen($mdMenu, $event) {
    $mdMenu.open($event);
  }

  onPrint() {
    this.routesService.printRoutes(this.selectedIds);
  }

  onPrintIkea() {
    let serviceIds = [];
    this.selectedRoutes.forEach((r) => {
      serviceIds = serviceIds.concat(_.uniq(r.routeTaskList.filter(t => t.taskType === this.taskTypes.Stopover).map(t => t.serviceId)));
    })
    this.deliveriesRef.$asyncValues(serviceIds)
      .then((services) => {
        this.commonsDialogService.printIkea(services);
      })
  }

  onPrintLoadingSheet() {
    this.routesService.printLoadingSheet(this.selectedIds);
  }

  onPrintBillOfLading() {
    this.routesService.onPrintBOL(this.selectedIds);
  }

  onDownloadBillOfLading() {
    this.routesService.onDownloadBOL(this.selectedIds);
  }

  onCancelRouteServices($event) {
    let serviceIds = [];
    this.selectedRoutes.forEach((r) => {
      r.routeTaskList.filter(t => this._isCancelableTask(t)).forEach((t) => {
        serviceIds = serviceIds.concat(t.bundleServiceIdList || [t.serviceId]);
      });
    });
    serviceIds = _.uniq(_.compact(serviceIds));
    if (_.isEmpty(serviceIds)) {
      return;
    }
    this.DeliveriesApiAction.cancel($event, serviceIds);
  }

  private _getSelectedRoutes() {
    return this.routesRef.$asyncValues(this.selectedIds);
  }






  // private initRouteActions() {
  //   if (!this.route) {
  //     return;
  //   }
  //   this.activeActionsMap = this.leanPlanningService.getRoutesActionsMap([this.route]);
  //
  //   this._setEditableBoundedEquipment(this.route);
  // }

  private _setEditableBoundedEquipment(route) {
    (route.taskListExt || []).forEach((task: TaskModel) => {
      if (task.subTasks && (task.taskSpec.purpose === 'StartRoute' || task.taskSpec.purpose === 'EndRoute')) {

        const bindingSubTask = _.find(task.subTasks, (st) => {
          return _.find(st.actions, (ac) => {
            return ac.type === "VehicleBinding";
          })
        })
        if (!!bindingSubTask) {
          this.bindingTask = task;
        }
      }
    })
  }

  private _setTotals() {
    this.totals = {
      numberOfItems: _.reduce(_.flatMap(this.selectedRoutes, 'totalLoad.numberOfItems'), (sum, count: number) => {
        sum += count;
        return sum;
      }, 0),
      weightLoad: _.reduce(_.flatMap(this.selectedRoutes, 'maxLoad.weightLoad'), (sum, weight: number) => {
        sum += weight;
        return sum;
      }, 0),
      calculatedVolume: _.reduce(_.flatMap(this.selectedRoutes, 'maxLoad.calculatedVolume'), (sum, volume: number) => {
        sum += volume;
        return sum;
      }, 0)
    }
  }

}


angular
  .module('bringoz.admin.routes')
  .component('routesActionBar', {
    bindings: {
      excludeMode: '<',
      totalRoutes: '<?',
      showTotalsRow: '<?',
      allRoutesCount: '<?',
      displayAsIcon: '<?',
      onlyExport: '<?',
      selectedIds: '<',
      selectedRoutes: '<',
      onAssignAndSelect: '&',
      onAssign: '&',
      onDelete: '&',
      onMerge: '&',
      onReset: '&',
      onUpdateBranches: '&',
      onExport: '&',
      onExportIntegration: '&',
      onHandleUnpackedServices: '&',
      onReoptimizeRoute: '&',
      onLockRoute: '&',
      onUnlockRoute: '&',
      onUpdateResource: '&',
      onUpdateLogisticsVehicleRoute: '&',
      onManageAssistants: '&',
      onChangeRouteColor: '&',
      onResetSelection: '&',
      onAssociate: '&'
    },
    template: require('./routes-action-bar.html').default,
    controller: RoutesActionBarComponent
  });
